import $ from 'jquery';

import {
	userSelectorObject,
	__deprecated__recipeObject,
	restCall,
	getDOMElements
} from '../common/utilities.js';

import Field from '../field';

import Actions from '../item/actions.js';

import RecipeNotices from '../recipe/notices.js';

import Tokens from '../tokens';

// Import global utils
import { isEmpty } from '@automator/shared/utils/is-empty';
import { addParametersUTM } from '@automator/shared/utils/add-parameters-utm-to-url';

// Import escapeHTML
import { escapeHTML } from '@wordpress/escape-html';

// Import i18n functions
import { __, _x, sprintf } from '@wordpress/i18n';

// Import recipe builder services
import { evaluateRecipeRequiresUserData, setRequiresUserSelector } from '@automator/builder/services/user-selector';

class UserSelector {
	constructor(){
		// On page load, get current step
		UncannyAutomator.recipe.userSelector.step = userSelectorObject( 'get-step' );

		// Render
		this.render();
	}

	render(){
		// Create variable to save the content to be added
		let $content = ``;

		// Get content depending of the step
		switch ( UncannyAutomator.recipe.userSelector.step ){
			case 'select-source':
				// Set validation to false
				// We're setting it to false here in case the user already
				// has valid values, but wanted to go to the first step
				// to change the source
				UncannyAutomator.recipe.userSelector.isValid = false;

				// Validate recipe
				__deprecated__recipeObject( 'validate' );

				// Where the recipe creator select the source of the user.
				// The options are "Existing user" and "New user".
				$content = this.getSelectSourceNodes();
				break;

			case 'set-options':
				// Where the recipe creator defines values of the fields
				$content = this.getOptionsNodes();
				break;

			case 'show-sentence':
				// Validate recipe
				__deprecated__recipeObject( 'validate' );

				// Set error mode
				UncannyAutomator.recipe.errorMode = false;

				// Show error
				new RecipeNotices();

				// When the data is complete and valid.
				$content = this.getSentenceNodes();
				break;
		}

		// Get container
		let $metabox = getDOMElements( 'metabox', {
			type: 'action'
		});

		// Append content
		$metabox.prepend( $content );
	}

	getSelectSourceNodes(){
		// Create elements
		let $userSelector = $( `
			<div class="user-selector ${ UncannyAutomator.recipe.requiresUserData ? 'user-selector--show' : '' }">
			</div>	
		` );

		// Add header
		$userSelector.append( this.createItem() );

		// Add content
		$userSelector.find( '.uap-item-inner-content' ).append( $( `
			<div class="item-integrations">
				<div class="item-integration user-selector-option user-selector-option--existing-user" data-source="existingUser">
					<div class="item-integration__logo"></div>
					<div class="item-integration__name">
						${ escapeHTML( __( 'Existing user', 'uncanny-automator' ) ) }
					</div>
				</div>
				<div class="item-integration user-selector-option user-selector-option--new-user" data-source="newUser">
					<div class="item-integration__logo"></div>
					<div class="item-integration__name">
						${ escapeHTML( __( 'New user', 'uncanny-automator' ) ) }
					</div>
				</div>
			</div>
		` ) );

		// Get user type boxes
		let $userTypeButtons = $userSelector.find( '.user-selector-option' );

		// Bind click on the user type buttons
		$userTypeButtons.on( 'click', ( event ) => {
			// Get clicked button
			let $option = $( event.currentTarget );

			// Get user type
			let userSource = $option.data( 'source' );
			
			// Save selected source in main object
			userSelectorObject( 'set-source', {
				source: userSource
			});

			// Define next step
			UncannyAutomator.recipe.userSelector.step = 'set-options';

			// Render the actions metabox again
			new Actions();
		});

		// Return element
		return $userSelector;
	}

	getOptionsNodes(){
		// Create elements
		let $optionsContainer = $( `
			<div class="user-selector ${ UncannyAutomator.recipe.requiresUserData ? 'user-selector--show' : '' }">
			</div>
		` );

		// Add header
		$optionsContainer.prepend( this.createItem() );

		// Add content
		$optionsContainer.find( '.uap-item-inner-content' ).append( $( `<div class="item-options"></div>` ) );

		// Get options container, we will add the fields there
		let $fieldsContainer = $optionsContainer.find( '.item-options' );

		// Add fields
		$fieldsContainer.append( this.getOptionsFields() );

		// Return node
		return $optionsContainer;
	}

	getOptionsFields(){
		// Create container
		const $container = $( `<div></div>` );

		// Create the fields container
		let $fields = $( `<div class="item-options__group"></div>` );

		// Create array to save all the fields
		let optionsFields = [];

		// Update fields data object so it's an object and not an array
		userSelectorObject( 'update-fields', {
			source: 'existingUser',
			data: {}
		});

		userSelectorObject( 'update-fields', {
			source: 'newUser',
			data: {}
		});

		// Get WordPress roles, but remove the "administrator" one
		let roles = UncannyAutomator.recipe.userSelector.resources.roles;
		delete roles.administrator;

		// Check what's the source
		switch ( UncannyAutomator.recipe.userSelector.source ){
			case 'existingUser':
				// Create group
				let $groupOfFields = $( `<div class="user-selector__field-group user-selector__field-group--two-columns"></div>` );

				// Create "Unique field" field
				let uniqueField = new Field( 'select', {
					itemType: 'user-selector',
					optionCode: 'uniqueField',
					label: escapeHTML( __( 'Unique field', 'uncanny-automator' ) ),
					currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.uniqueField,
					isRequired: true,
					optionsShowID: false,
					options: [
						{
							value: 'email',
							text:  escapeHTML( __( 'Email', 'uncanny-automator' ) )
						},
						{
							value: 'id',
							text:  escapeHTML( __( 'ID', 'uncanny-automator' ) )
						},
						{
							value: 'username',
							text:  escapeHTML( __( 'Username', 'uncanny-automator' ) )
						},
					]
				});
				optionsFields.push( uniqueField );

				// Create value field
				let valueField = new Field( 'text', {
					itemType: 'user-selector',
					optionCode: 'uniqueFieldValue',
					currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.uniqueFieldValue,
					label: escapeHTML( __( 'Value', 'uncanny-automator' ) ),
					// placeholder: escapeHTML( __( 'Value of the unique field', 'uncanny-automator' ) ),
					isRequired: true,
					supportsTokens: true
				});
				optionsFields.push( valueField );

				// Create and add form element
				let $uniqueFieldFormElement = uniqueField.getFormElement();

				// Init Codemirror
				// AFTER we added the elements to the DOM let's call init 
				// TokenSelector and CodeMirror. We're going to call this in
				// ItemOptions.js because the TokenSelector and 
				// CodeMirror need the item in the DOM before changing it
				valueField.initTokenSelector();
				valueField.initFlatpickr();
				valueField.initCodeMirror();

				$groupOfFields.append( $uniqueFieldFormElement );

				let $valueFieldFormElement = valueField.getFormElement();
				$groupOfFields.append( $valueFieldFormElement );

				// Add elements to the main container
				$fields.append( $groupOfFields );

				// Create field to decide what to do if the user doesn't exist
				let fallbackField = new Field( 'radio', {
					itemType: 'user-selector',
					optionCode: 'fallback',
					name: 'user-selector-existing-user-fallback',
					label: escapeHTML( __( "What to do if the user doesn't exist", 'uncanny-automator' ) ),
					isRequired: true,
					currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.fallback,
					options: [
						{
							value: 'create-new-user',
							text: escapeHTML( __( 'Create new user', 'uncanny-automator' ) )
						},
						{
							value: 'do-nothing',
							text: escapeHTML( __( 'Do nothing', 'uncanny-automator' ) )
						}
					]
				});
				optionsFields.push( fallbackField );

				// Create and add form element
				let $fallbackFieldFormElement = fallbackField.getFormElement();
				$fields.append( $fallbackFieldFormElement );

				// Listen changes
				$uniqueFieldFormElement.on( 'automator:field:change', () => {
					// Get and save value
					userSelectorObject( 'update-fields', {
						source: 'existingUser',
						data: {
							uniqueField: uniqueField.getValue()
						}
					});
				});

				$valueFieldFormElement.on( 'automator:field:change', () => {
					// Get and save value
					userSelectorObject( 'update-fields', {
						source: 'existingUser',
						data: {
							uniqueFieldValue: valueField.getValue()
						}
					});
				});

				// Listen changes
				$fallbackFieldFormElement.on( 'automator:field:change', () => {
					// Get and save value
					userSelectorObject( 'update-fields', {
						source: 'existingUser',
						data: {
							fallback: fallbackField.getValue()
						}
					});

					// Render the actions metabox again
					new Actions();
				});

				// Check if we have to add more fields or the do-nothing notice
				if ( UncannyAutomator.recipe.userSelector.data.existingUser.fallback == 'do-nothing' ){
					// Create "Do nothing" notice
					const $doNothingNotice = $( `
						<div class="user-selector__warning">
							${ escapeHTML( __( 'If no user matches the unique field and value then the actions are not going to be executed.', 'uncanny-automator' ) ) }
						</div>
					` );

					$fields.append( $doNothingNotice );
				}
				else if ( UncannyAutomator.recipe.userSelector.data.existingUser.fallback == 'create-new-user' ){
					// Create container
					let $subOptionsContainer = $( '<div/>', {
						'class': 'item-options'
					});

					// Create new users fields
					let newUserFields = [
						{
							itemType:   'user-selector',
							fieldType:  'text',
							optionCode: 'firstName',
							currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.firstName,
							label: escapeHTML( __( 'First name', 'uncanny-automator' ) ),
							isRequired: false,
							supportsTokens: true
						},
						{
							itemType:   'user-selector',
							fieldType:  'text',
							optionCode: 'lastName',
							currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.lastName,
							label: escapeHTML( __( 'Last name', 'uncanny-automator' ) ),
							isRequired: false,
							supportsTokens: true
						},
						{
							itemType:   'user-selector',
							fieldType:  'text',
							optionCode: 'email',
							currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.email,
							label: escapeHTML( __( 'Email', 'uncanny-automator' ) ),
							isRequired: true,
							supportsTokens: true
						},
						{
							itemType:   'user-selector',
							fieldType:  'text',
							optionCode: 'username',
							currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.username,
							label: escapeHTML( __( 'Username', 'uncanny-automator' ) ),
							isRequired: true,
							supportsTokens: true
						},
						{
							itemType:   'user-selector',
							fieldType:  'text',
							optionCode: 'displayName',
							currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.displayName,
							label: escapeHTML( __( 'Display name', 'uncanny-automator' ) ),
							isRequired: false,
							supportsTokens: true
						},
						{
							itemType:   'user-selector',
							fieldType:  'text',
							optionCode: 'password',
							currentValue: UncannyAutomator.recipe.userSelector.data.existingUser.password,
							label: escapeHTML( __( 'Password', 'uncanny-automator' ) ),
							/* translators: 1. Token name */
							description: escapeHTML( __( 'If left empty, the user will need to reset their password to log in. Send an email containing the _User reset password link_ token to simplify the process.', 'uncanny-automator' ) ),
							isRequired: false,
							supportsTokens: true
						},
						{
							itemType:   'user-selector',
							fieldType:  'select',
							optionCode: 'role',
							currentValue: ! isEmpty( UncannyAutomator.recipe.userSelector.data.existingUser.role ) ? UncannyAutomator.recipe.userSelector.data.existingUser.role : 'subscriber',
							/* translators: WordPress roles */
							label: escapeHTML( __( 'Role', 'uncanny-automator' ) ),
							isRequired: true,
							supportsTokens: false,
							optionsShowID: false,
							options: Object.keys( roles ).map( ( key, index ) => {
								return {
									value: key,
									text:  roles[ key ]
								}
							})
						},
						{
							itemType: 'user-selector',
							fieldType: 'radio',
							optionCode: 'logUserIn',
							name: 'logUserIn',
							currentValue: UncannyAutomator.recipe.canLogNewUserIn ? ( ! isEmpty( UncannyAutomator.recipe.userSelector.data.existingUser.logUserIn ) ? UncannyAutomator.recipe.userSelector.data.existingUser.logUserIn : 'no' ) : 'no',
							isHidden: ! UncannyAutomator.recipe.canLogNewUserIn,
							label: escapeHTML( __( 'Log the new user in?', 'uncanny-automator' ) ),
							supportsTokens: false,
							options: [{
									value: 'yes',
									text:  escapeHTML( __( 'Yes', 'uncanny-automator' ) )
								},
								{
									value: 'no',
									text:  escapeHTML( __( 'No', 'uncanny-automator' ) )
								}
							]
						}
					];

					// Create fields
					newUserFields.forEach(( fieldObject ) => {
						// Create field
						const field = new Field( fieldObject.fieldType, fieldObject );

						// Get container
						let $fieldFormElement = field.getFormElement();

						$subOptionsContainer.append( $fieldFormElement );

						// AFTER we added the elements to the DOM let's call init 
						// TokenSelector and CodeMirror. We're going to call this in
						// ItemOptions.js because the TokenSelector and 
						// CodeMirror need the item in the DOM before changing it
						field.initTokenSelector();
						field.initFlatpickr();
						field.initCodeMirror();

						/**
						 * We don't need this for now, but we could need it in the future
						 * 

						// Listen changes
						$fieldFormElement.on( 'automator:field:change', () => {
							// Get ID
							const fieldId = fieldObject.optionCode;

							// Get value
							const value = field.getValue();
						});

						*/

						// Save field
						optionsFields.push( field );
					});

					// Append container
					$fields.append( $subOptionsContainer );
				}
				break;

			case 'newUser':
				// Create new users fields
				let newUserFields = [
					{
						itemType:   'user-selector',
						fieldType:  'text',
						optionCode: 'firstName',
						currentValue: UncannyAutomator.recipe.userSelector.data.newUser.firstName,
						label: escapeHTML( __( 'First name', 'uncanny-automator' ) ),
						isRequired: false,
						supportsTokens: true
					},
					{
						itemType:   'user-selector',
						fieldType:  'text',
						optionCode: 'lastName',
						currentValue: UncannyAutomator.recipe.userSelector.data.newUser.lastName,
						label: escapeHTML( __( 'Last name', 'uncanny-automator' ) ),
						isRequired: false,
						supportsTokens: true
					},
					{
						itemType:   'user-selector',
						fieldType:  'text',
						optionCode: 'email',
						currentValue: UncannyAutomator.recipe.userSelector.data.newUser.email,
						label: escapeHTML( __( 'Email', 'uncanny-automator' ) ),
						isRequired: true,
						supportsTokens: true
					},
					{
						itemType:   'user-selector',
						fieldType:  'text',
						optionCode: 'username',
						currentValue: UncannyAutomator.recipe.userSelector.data.newUser.username,
						label: escapeHTML( __( 'Username', 'uncanny-automator' ) ),
						isRequired: true,
						supportsTokens: true
					},
					{
						itemType:   'user-selector',
						fieldType:  'text',
						optionCode: 'displayName',
						currentValue: UncannyAutomator.recipe.userSelector.data.newUser.displayName,
						label: escapeHTML( __( 'Display name', 'uncanny-automator' ) ),
						isRequired: false,
						supportsTokens: true
					},
					{
						itemType:   'user-selector',
						fieldType:  'text',
						optionCode: 'password',
						currentValue: UncannyAutomator.recipe.userSelector.data.newUser.password,
						label: escapeHTML( __( 'Password', 'uncanny-automator' ) ),
						/* translators: 1. Token name */
						description: escapeHTML( __( 'If left empty, the user will need to reset their password to log in. Send an email containing the _User reset password link_ token to simplify the process.', 'uncanny-automator' ) ),
						isRequired: false,
						supportsTokens: true
					},
					{
						itemType:   'user-selector',
						fieldType:  'select',
						optionCode: 'role',
						currentValue: ! isEmpty( UncannyAutomator.recipe.userSelector.data.newUser.role ) ? UncannyAutomator.recipe.userSelector.data.newUser.role : 'subscriber',
						/* translators: WordPress roles */
						label: escapeHTML( __( 'Role', 'uncanny-automator' ) ),
						isRequired: true,
						supportsTokens: false,
						optionsShowID: false,
						options: Object.keys( roles ).map( ( key, index ) => {
							return {
								value: key,
								text:  roles[ key ]
							}
						})
					},
					{
						itemType: 'user-selector',
						fieldType: 'radio',
						optionCode: 'logUserIn',
						name: 'logUserIn',
						currentValue: UncannyAutomator.recipe.canLogNewUserIn ? ( ! isEmpty( UncannyAutomator.recipe.userSelector.data.newUser.logUserIn ) ? UncannyAutomator.recipe.userSelector.data.newUser.logUserIn : 'no' ) : 'no',
						isHidden: ! UncannyAutomator.recipe.canLogNewUserIn,
						label: escapeHTML( __( 'Log the new user in?', 'uncanny-automator' ) ),
						supportsTokens: false,
						options: [{
								value: 'yes',
								text:  escapeHTML( __( 'Yes', 'uncanny-automator' ) )
							},
							{
								value: 'no',
								text:  escapeHTML( __( 'No', 'uncanny-automator' ) )
							}
						]
					}
				];

				// Create fields
				newUserFields.forEach(( fieldObject ) => {
					// Create field
					const field = new Field( fieldObject.fieldType, fieldObject );

					// Get container
					let $fieldFormElement = field.getFormElement();

					$fields.append( $fieldFormElement );

					// AFTER we added the elements to the DOM let's call init 
					// TokenSelector and CodeMirror. We're going to call this in
					// ItemOptions.js because the TokenSelector and 
					// CodeMirror need the item in the DOM before changing it
					field.initTokenSelector();
					field.initFlatpickr();
					field.initCodeMirror();

					// Save field
					optionsFields.push( field );
				});

				// Create fallback field
				let newUserFallbackField = new Field( 'radio', {
					itemType:   'user-selector',
					optionCode: 'fallback',
					name: 'user-selector-new-user-fallback',
					label: escapeHTML( __( 'What to do if the user already exists', 'uncanny-automator' ) ),
					isRequired: true,
					currentValue: UncannyAutomator.recipe.userSelector.data.newUser.fallback,
					options: [
						{
							value: 'select-existing-user',
							text: escapeHTML( __( 'Select existing user', 'uncanny-automator' ) )
						},
						{
							value: 'do-nothing',
							text: escapeHTML( __( 'Do nothing', 'uncanny-automator' ) )
						}
					]
				});
				optionsFields.push( newUserFallbackField );

				// Add fallback field to the container
				let $newUserfallbackFieldFormElement = newUserFallbackField.getFormElement();
				$fields.append( $newUserfallbackFieldFormElement );

				// Listen changes
				$newUserfallbackFieldFormElement.on( 'automator:field:change', () => {
					// Update the value of all the fields (don't validate them yet)
					let fieldsValues = {};

					// Iterate fields
					optionsFields.forEach(( Field ) => {
						// Save the field using the optionCode as ID and field value as value
						fieldsValues[ Field.getAttributes().optionCode ] = Field.getValue();
					});

					// Get and save value
					userSelectorObject( 'update-fields', {
						source: 'newUser',
						data: fieldsValues
					});

					// Render the actions metabox again
					new Actions();
				});

				// Check if we have to add more fields or the do-nothing notice
				if ( UncannyAutomator.recipe.userSelector.data.newUser.fallback == 'do-nothing' ){
					// Create "Do nothing" notice
					const $doNothingNotice = $( `
						<div class="user-selector__warning">
							${ escapeHTML( __( 'If there is already a user with the defined email address or username, the actions are not going to be executed.', 'uncanny-automator' ) ) }
						</div>
					` );

					$fields.append( $doNothingNotice );
				}
				else if ( UncannyAutomator.recipe.userSelector.data.newUser.fallback == 'select-existing-user' ){
					// Create container
					let $subOptionsContainer = $( '<div/>', {
						'class': 'item-options'
					});

					// Create "Prioritized Field" field
					let prioritizedField = new Field( 'select', {
						itemType:     'user-selector',
						optionCode:   'prioritizedField',
						label:        escapeHTML( __( 'Prioritized field', 'uncanny-automator' ) ),
						currentValue: UncannyAutomator.recipe.userSelector.data.newUser.prioritizedField,
						defaultValue: 'email',
						description:  escapeHTML( __( 'Select the field that should be prioritized if, during creation of the user, two different users are found (one that matches the email field and another one that matches the username field).', 'uncanny-automator' ) ),
						isRequired:   true,
						optionsShowID: false,
						options: [
							{
								value: 'email',
								text:  escapeHTML( __( 'Email', 'uncanny-automator' ) )
							},
							{
								value: 'username',
								text:  escapeHTML( __( 'Username', 'uncanny-automator' ) )
							},
						]
					});
					optionsFields.push( prioritizedField );

					// Get field container
					let $prioritizedField = prioritizedField.getFormElement();
					$subOptionsContainer.append( $prioritizedField );

					// Append container
					$fields.append( $subOptionsContainer );
				}

				break;
		}

		// Save fields
		UncannyAutomator.recipe.userSelector.fields = optionsFields;

		// Add fields
		$container.append( $fields );

		// Create and add save and cancel buttons
		const $buttonsContainer = $( `<div class="item-options__buttons"></div>` );

		// Save button
		const $saveButton = $( `<div class="uap-btn uap-btn--primary">${ escapeHTML( _x( 'Save', 'Verb', 'uncanny-automator' ) ) }</div>` );
		const $cancelButton = $( `<div class="uap-btn uap-btn--secondary">${ escapeHTML( _x( 'Cancel', 'Verb', 'uncanny-automator' ) ) }</div>` );

		// Add listeners
		// On save
		$saveButton.on( 'click', () => {
			// Validate fields
			// Create default response
			let areAllFieldsValid = true;

			// Create object to get all the fields values
			let fieldsValues = {}

			// Iterate fields and validate them
			optionsFields.forEach(( Field ) => {
				// Get field validation
				const isFieldValid = Field.validate().isValid;

				// Update global validation
				areAllFieldsValid = areAllFieldsValid && isFieldValid;

				// Check if the field is valid
				if ( isFieldValid ){
					// Save value
					fieldsValues[ Field.getAttributes().optionCode ] = Field.getValue();
				}
			});

			// Save values
			userSelectorObject( 'update-fields', {
				source: UncannyAutomator.recipe.userSelector.source,
				data: fieldsValues
			});

			// Check if all fields are valid, otherwise
			// do nothing. The .validate() method will
			// render the errors
			if ( areAllFieldsValid ){
				// Add loading class to button
				$saveButton.addClass( 'uap-btn--primary uap-btn--loading uap-btn--disabled' );

				// Make request
				restCall( 'user-selector', {
					recipeId: UncannyAutomator._recipe.recipe_id,
					source: UncannyAutomator.recipe.userSelector.source,
					data: UncannyAutomator.recipe.userSelector.data[ UncannyAutomator.recipe.userSelector.source ]
				}, ( response ) => {
					// On success
					// Set user selector as valid
					UncannyAutomator.recipe.userSelector.isValid = true;

					// Set step
					userSelectorObject( 'set-step', {
						step: 'show-sentence'
					});

					// Render actions again
					new Actions();
				}, ( response ) => {
					// On error
				});
			}
		});

		// On cancel
		$cancelButton.on( 'click', () => {
			// Delete fields information
			// userSelectorObject( 'reset-fields' );

			// Set step
			userSelectorObject( 'set-step', {
				step: 'select-source'
			});

			// Render actions again
			new Actions();
		})

		// Add buttons
		$buttonsContainer.append( $saveButton );
		$buttonsContainer.append( $cancelButton );
		$container.append( $buttonsContainer );

		return $container;
	}

	getSentenceNodes(){
		// Create elements
		let $optionsContainer = $( `
			<div class="user-selector user-selector--summary ${ UncannyAutomator.recipe.requiresUserData ? 'user-selector--show' : '' }">
			</div>
		` );

		// Add header
		$optionsContainer.prepend( this.createItem() );

		// Add content
		$optionsContainer.find( '.uap-item-inner-content' ).append( $( `<div class="user-selector-summary"></div>` ) );

		// Get container
		let $summaryContainer = $optionsContainer.find( '.user-selector-summary' );

		// Create first row
		let $sourceRow = $( `
			<div class="user-selector-summary-row">
				<div class="user-selector-summary-row__icon">
					<uo-icon id="atom-simple"></uo-icon>
				</div>
				<div class="user-selector-summary-row__content"></div>
			</div>
		` );

		// Create token
		let $sourceRowToken = $( `
			<div class="user-selector-summary-row__token"></div>
		` );
		$sourceRow.find( '.user-selector-summary-row__content' ).append( $sourceRowToken );

		// If the source is "existingUser"
		if ( UncannyAutomator.recipe.userSelector.source == 'existingUser' ){
			// Then add the "Existing user" string
			$sourceRowToken.text( escapeHTML( __( 'Existing user', 'uncanny-automator' ) ) );
		}
		// If it's "newUser"
		else if ( UncannyAutomator.recipe.userSelector.source == 'newUser' ){
			// Then add the "New user" string
			$sourceRowToken.text( escapeHTML( __( 'New user', 'uncanny-automator' ) ) );
		}

		// Listen clicks
		$sourceRowToken.on( 'click', () => {
			// Go to the first step.
			
			// Delete fields information
			// userSelectorObject( 'reset-fields' );

			// Set step
			userSelectorObject( 'set-step', {
				step: 'select-source'
			});

			// Render actions again
			new Actions();
		});

		// Add to container
		$summaryContainer.append( $sourceRow );

		// Create first row
		let $dataRow = $( `
			<div class="user-selector-summary-row">
				<div class="user-selector-summary-row__icon">
					<uo-icon id="fingerprint"></uo-icon>
				</div>
				<div class="user-selector-summary-row__content"></div>
			</div>
		` );

		// Create token
		let $dataRowSentence;

		// Beautify text in "x matches y" by rendering tokens in "y"
		let uniqueFieldValue = UncannyAutomator.recipe.userSelector.data.existingUser.uniqueFieldValue;
		try {
			// Render tokens
			uniqueFieldValue = ( new Tokens( 'user-selector' ) ).renderTextWithTokens( uniqueFieldValue ).outerHTML;
		} catch ( e ){
			// Output error if the developer mode is enabled
			if ( UncannyAutomator._site.has_debug_enabled ){
				// eslint-disable-next-line no-console
				console.warn( e );
			}
		}

		if ( UncannyAutomator.recipe.userSelector.source == 'existingUser' ){			
			$dataRowSentence = $( `
				<div>
				${
					sprintf(
						/* translators: 1. Field name, 2. Field value */
						escapeHTML( _x( '%1$s matches %2$s', 'User selector', 'uncanny-automator' ) ),
						`<div class="user-selector-summary-row__token">${ 
							{
								email:    escapeHTML( __( 'Email', 'uncanny-automator' ) ),
								id:       escapeHTML( __( 'ID', 'uncanny-automator' ) ),
								username: escapeHTML( __( 'Username', 'uncanny-automator' ) )
							}[ UncannyAutomator.recipe.userSelector.data.existingUser.uniqueField ]
						}</div>`,
						`<div class="user-selector-summary-row__token">${ uniqueFieldValue }</div>`
					)
				}
				</div>`
			);
		}
		else if ( UncannyAutomator.recipe.userSelector.source == 'newUser' ){
			// Beautify text in "x matches y" by rendering tokens in "y"
			let uniqueFieldValue = UncannyAutomator.recipe.userSelector.data.newUser.email;
			try {
				// Render tokens
				uniqueFieldValue = ( new Tokens( 'user-selector' ) ).renderTextWithTokens( uniqueFieldValue ).outerHTML;
			} catch ( e ){
				// Output error if the developer mode is enabled
				if ( UncannyAutomator._site.has_debug_enabled ){
					// eslint-disable-next-line no-console
					console.warn( e );
				}
			}

			$dataRowSentence = $( `
				<div>
				${
					sprintf(
						/* translators: 1. An email address */
						escapeHTML( _x( 'With the email %1$s', 'User selector', 'uncanny-automator' ) ),
						`<div class="user-selector-summary-row__token">${ uniqueFieldValue }</div>`
					)
				}
				</div>
				`
			);
		}

		$dataRow.find( '.user-selector-summary-row__content' ).append( $dataRowSentence );

		// Listen clicks
		$dataRowSentence.find( '.user-selector-summary-row__token' ).on( 'click', () => {
			// Go to the second step.
			
			// Set step
			userSelectorObject( 'set-step', {
				step: 'set-options'
			});

			// Render actions again
			new Actions();
		});

		// Add data row
		$summaryContainer.append( $dataRow );

		// Add fallback row
		let $fallbackRow = $( `
			<div class="user-selector-summary-row">
				<div class="user-selector-summary-row__icon">
					<uo-icon id="diamond-turn-right"></uo-icon>
				</div>
				<div class="user-selector-summary-row__content"></div>
			</div>
		` );

		let otherwiseText = '';

		if ( UncannyAutomator.recipe.userSelector.source == 'existingUser' ){
			if ( UncannyAutomator.recipe.userSelector.data.existingUser.fallback == 'create-new-user' ){
				otherwiseText = escapeHTML( _x( 'create a new user', 'User selector', 'uncanny-automator' ) );
			}
			else if ( UncannyAutomator.recipe.userSelector.data.existingUser.fallback == 'do-nothing' ){
				otherwiseText = escapeHTML( _x( 'do nothing', 'User selector', 'uncanny-automator' ) );
			}
		}
		else if ( UncannyAutomator.recipe.userSelector.source == 'newUser' ){
			if ( UncannyAutomator.recipe.userSelector.data.newUser.fallback == 'select-existing-user' ){
				otherwiseText = escapeHTML( _x( 'select an existing user', 'User selector', 'uncanny-automator' ) );
			}
			else if ( UncannyAutomator.recipe.userSelector.data.newUser.fallback == 'do-nothing' ){
				otherwiseText = escapeHTML( _x( 'do nothing', 'User selector', 'uncanny-automator' ) );
			}
		}

		let $fallbackRowSentence = $( `
			<div>
			${
				sprintf(
					/* translators: 1. An action */
					escapeHTML( _x( 'Otherwise, %1$s', 'User selector', 'uncanny-automator' ) ),
					`<div class="user-selector-summary-row__token">${ otherwiseText }</div>`
				)
			}
			</div>`
		);
		$fallbackRow.find( '.user-selector-summary-row__content' ).append( $fallbackRowSentence );

		// Listen clicks
		$fallbackRow.find( '.user-selector-summary-row__token' ).on( 'click', () => {
			// Go to the second step.

			// Set step
			userSelectorObject( 'set-step', {
				step: 'set-options'
			});

			// Render actions again
			new Actions();
		});

		// Add data row
		$summaryContainer.append( $fallbackRow );

		// Return nodes
		return $optionsContainer;
	}

	createItem(){
		// Get the content
		const content = {
			// Step title
			stepTitle: UncannyAutomator.recipe.userSelector.step == 'set-options' ? escapeHTML( __( 'Set user data', 'uncanny-automator' ) ) : escapeHTML( __( 'Actions will be run on...', 'uncanny-automator' ) ),

			// Support URL
			supportUrl: addParametersUTM(
				'https://automatorplugin.com/knowledge-base/anonymous-recipes/#Introducing_the_User_Selector',
				{
					'medium':  'user_selector',
					'content': 'support_menu_link'
				}
			),
		}

		// Create template
		const $template = document.createElement( 'div' );
		$template.classList.add( 'uap-item', 'uap-item--user-selector', 'item', 'item--user-selector' );

		// Add content
		$template.innerHTML = `
			<div class="uap-item-inner">
				<div class="uap-item-sidebar">
					<ua-builder-integration-icon code="UOA"></ua-builder-integration-icon>
				</div>
				<div class="uap-item-top-header">
					<div class="uap-item-top-header-left">
						${ content.stepTitle }
					</div>
					<div class="uap-item-top-header-right">
						<uo-button-dropdown reverse-direction>
							<uo-button 
								slot="target" 
								color="transparent"
								size="small"
							>
								<uo-icon id="ellipsis"></uo-icon>
							</uo-button>

							<uo-button
								href="${ content.supportUrl }"
								target="_blank"
							>
								${ escapeHTML( _x( 'Support', 'Noun', 'uncanny-automator' ) ) }
							</uo-button>

						</uo-button-dropdown>
					</div>
				</div>
				<div class="uap-item-inner-content"></div>
			</div>
		`;

		// Check if the user can remove the user selector
		if ( ! evaluateRecipeRequiresUserData() ) {
			// Create delete item
			const $deleteButton = document.createElement( 'uo-button' );
			$deleteButton.innerText = escapeHTML( __( 'Delete', 'uncanny-automator' ) );

			// Get the container
			const $buttonsDropdown = $template.querySelector( '.uap-item-top-header-right uo-button-dropdown' );

			if ( $buttonsDropdown ) {
				$buttonsDropdown.appendChild( $deleteButton );
			}

			// Do call on click
			$deleteButton.addEventListener( 'click', () => {
				setRequiresUserSelector( false )
					/**
					 * @todo Remove this once the new _recipe object is used
					 */
					.then( response => {
						// Update the global "requiresData"
						UncannyAutomator.recipe.requiresUserData = false;

						// Render actions again
						new Actions();
					} );
			} );
		}

		// Return output
		return $template;
	}
}

export default UserSelector;
